/* component-order-instructions.js
   Syncs order notes automatically in the cart sidebar  */

document.addEventListener('DOMContentLoaded', () => {
  const noteField = document.querySelector('textarea[name="note"]');
  if (!noteField) return;

  noteField.addEventListener('change', debounce(() => {
    fetch(window.routes.cart_change_url || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: noteField.value })
    });
  }, 500));
});

// simple debounce helper (only if not already defined globally)
function debounce(fn, wait) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
